module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_blue.a5433427.svg";